import { create } from 'zustand';
import { ApiUtils, ApplicationApi, type ApplicationItem, type ApplicationSearchParams, RequestStrategyEnum } from '@shared/api';

interface UseApplicationsStore {
  loading: boolean;
  data: ApplicationItem[];
  error: string | null;
  getApplications: (searchParams?: ApplicationSearchParams, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useApplicationsStore = create<UseApplicationsStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getApplications: ApiUtils.wrapperApi(async (searchParams = {}, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await ApplicationApi.getApplications(searchParams, signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
